(() => {
  (function() {
    if (isMetaInAppBrowser()) {
      disableCrossDocumentViewTransitions();
    }
    const viewTransitionRenderBlocker = document.getElementById("view-transition-render-blocker");
    const activation = window.navigation && window.navigation.activation;
    const noTransitionPossible = activation && (activation.from === null || activation.navigationType === "reload");
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches || isLowPowerDevice() || noTransitionPossible) {
      viewTransitionRenderBlocker == null ? void 0 : viewTransitionRenderBlocker.remove();
    } else {
      const RENDER_BLOCKER_TIMEOUT_MS = Math.max(0, 1800 - performance.now());
      setTimeout(() => {
        viewTransitionRenderBlocker == null ? void 0 : viewTransitionRenderBlocker.remove();
      }, RENDER_BLOCKER_TIMEOUT_MS);
    }
    const idleCallback = typeof requestIdleCallback === "function" ? requestIdleCallback : setTimeout;
    window.addEventListener("pageswap", async (event) => {
      const { viewTransition } = (
        /** @type {PageSwapEvent} */
        event
      );
      if (shouldSkipViewTransition(viewTransition)) {
        viewTransition == null ? void 0 : viewTransition.skipTransition();
        return;
      }
      const skip = () => viewTransition.skipTransition();
      const events = ["pointerdown", "keydown"];
      events.forEach((eventName) => document.addEventListener(eventName, skip, { once: true }));
      const cleanup = () => events.forEach((eventName) => document.removeEventListener(eventName, skip));
      viewTransition.finished.then(cleanup, cleanup);
      document.querySelectorAll("[data-view-transition-type]:not([data-view-transition-triggered])").forEach((element) => {
        element.removeAttribute("data-view-transition-type");
      });
      const transitionTriggered = document.querySelector("[data-view-transition-triggered]");
      const transitionType = transitionTriggered == null ? void 0 : transitionTriggered.getAttribute("data-view-transition-type");
      if (transitionType) {
        viewTransition.types.clear();
        viewTransition.types.add(transitionType);
        storeTransitionType(transitionType);
      } else {
        viewTransition.types.clear();
        viewTransition.types.add("page-navigation");
        storeTransitionType(null);
      }
    });
    window.addEventListener("pagereveal", async (event) => {
      const { viewTransition } = (
        /** @type {PageRevealEvent} */
        event
      );
      if (shouldSkipViewTransition(viewTransition)) {
        viewTransition == null ? void 0 : viewTransition.skipTransition();
        return;
      }
      const customTransitionType = readTransitionType();
      if (customTransitionType) {
        viewTransition.types.clear();
        viewTransition.types.add(customTransitionType);
        await viewTransition.finished;
        viewTransition.types.clear();
        viewTransition.types.add("page-navigation");
        idleCallback(() => {
          storeTransitionType(null);
          document.querySelectorAll("[data-view-transition-type]").forEach((element) => {
            element.removeAttribute("data-view-transition-type");
          });
        });
      } else {
        viewTransition.types.clear();
        viewTransition.types.add("page-navigation");
      }
    });
    function shouldSkipViewTransition(viewTransition) {
      return !viewTransition || !viewTransition.types || typeof viewTransition.types.add !== "function" || typeof viewTransition.types.clear !== "function" || isLowPowerDevice() || prefersReducedMotion() || isMetaInAppBrowser();
    }
    function storeTransitionType(value) {
      try {
        if (value) sessionStorage.setItem("custom-transition-type", value);
        else sessionStorage.removeItem("custom-transition-type");
      } catch (error) {
      }
    }
    function readTransitionType() {
      try {
        return sessionStorage.getItem("custom-transition-type");
      } catch (error) {
        return null;
      }
    }
    function isMetaInAppBrowser(userAgent = navigator.userAgent) {
      const ua = userAgent || "";
      const androidWebView = /\bAndroid\b/i.test(ua) && /;\s?wv\)/i.test(ua);
      const knownInAppBrowser = /\b(FBAN|FBAV|FB_IAB|FBIOS|Instagram|musical_ly|Bytedance|BytedanceWebview|trill|TikTok)(?:\b|_)/i.test(ua);
      return androidWebView || knownInAppBrowser;
    }
    function disableCrossDocumentViewTransitions() {
      var _a;
      const style = document.createElement("style");
      style.textContent = "@view-transition { navigation: none; }";
      (document.head || document.documentElement).appendChild(style);
      (_a = document.getElementById("view-transition-render-blocker")) == null ? void 0 : _a.remove();
    }
    function prefersReducedMotion() {
      return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    }
    function isLowPowerDevice() {
      return Number(navigator.hardwareConcurrency) <= 2 || Number(navigator.deviceMemory) <= 2;
    }
  })();
})();
